/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
(function () {
  let updateTimer = null;

  function getCartRoot() {
    const host = document.querySelector(
      'section-store--cart-block'
    );

    if (!host || !host.shadowRoot) {
      return null;
    }

    return host.shadowRoot;
  }

  function getCartFooter() {
    const root = getCartRoot();

    if (!root) {
      return null;
    }

    return root.querySelector('.cart-footer');
  }

  /*
   * Find the actual text element that says
   * "Discount code".
   */
  function findDiscountText(footer) {
    const elements = Array.from(
      footer.querySelectorAll('*')
    );

    const matches = elements.filter(function (el) {
      const text = el.textContent
        .replace(/\s+/g, ' ')
        .trim();

      return text.startsWith('Discount code');
    });

    if (!matches.length) {
      return null;
    }

    /*
     * Use the smallest / innermost match.
     */
    matches.sort(function (a, b) {
      return (
        a.querySelectorAll('*').length -
        b.querySelectorAll('*').length
      );
    });

    return matches[0];
  }

  /*
   * Find the whole Discount code ROW.
   *
   * We climb upward until we reach the
   * direct child of .cart-footer.
   */
  function findDiscountRow(footer, textElement) {
    if (!textElement) {
      return null;
    }

    let row = textElement;

    while (
      row.parentElement &&
      row.parentElement !== footer
    ) {
      row = row.parentElement;
    }

    return row;
  }

  /*
   * Copy typography from the Discount
   * code text itself.
   */
  function copyTextStyles(target, reference) {
    if (!reference) {
      return;
    }

    const styles =
      window.getComputedStyle(reference);

    target.style.fontFamily =
      styles.fontFamily;

    target.style.fontSize =
      styles.fontSize;

    target.style.fontWeight =
      styles.fontWeight;

    target.style.fontStyle =
      styles.fontStyle;

    target.style.lineHeight =
      styles.lineHeight;

    target.style.letterSpacing =
      styles.letterSpacing;

    target.style.textTransform =
      styles.textTransform;

    target.style.color =
      styles.color;
  }

  /*
   * Copy the spacing/layout of the
   * actual Discount code row.
   */
  function copyRowSpacing(target, referenceRow) {
    if (!referenceRow) {
      return;
    }

    const styles =
      window.getComputedStyle(referenceRow);

    target.style.boxSizing =
      'border-box';

    target.style.paddingTop =
      styles.paddingTop;

    target.style.paddingRight =
      styles.paddingRight;

    target.style.paddingBottom =
      styles.paddingBottom;

    target.style.paddingLeft =
      styles.paddingLeft;

    target.style.marginTop =
      styles.marginTop;

    target.style.marginRight =
      styles.marginRight;

    target.style.marginBottom =
      styles.marginBottom;

    target.style.marginLeft =
      styles.marginLeft;

    /*
     * Match row alignment without copying
     * widths/heights that could cause issues.
     */
    target.style.display =
      styles.display;

    target.style.alignItems =
      styles.alignItems;

    target.style.justifyContent =
      styles.justifyContent;
  }

  function addStyles(root) {
    if (
      root.querySelector(
        '#dgt-cart-weight-styles'
      )
    ) {
      return;
    }

    const style =
      document.createElement('style');

    style.id =
      'dgt-cart-weight-styles';

    style.textContent = `
  .dgt-cart-weight {
    border: 0;
    background: transparent;
    text-align: left;
  }

  .dgt-cart-weight__text {
    display: block;
    padding: 0;
    margin: 0;
  }

  .dgt-cart-weight__shipping-note {
    display: block;
    margin-top: 3px;
    font-size: 0.85em;
    font-weight: 400;
    line-height: 1.3;
  }

  .dgt-cart-weight__shipping-note a {
    color: inherit;
    text-decoration: underline;
    font-weight: 400;
  }
`;

    root.appendChild(style);
  }

  async function updateCartWeight() {
    const root =
      getCartRoot();

    const footer =
      getCartFooter();

    if (!root || !footer) {
      return;
    }

    addStyles(root);

    /*
     * Find Sections Store's existing
     * Discount code row.
     */
    const discountText =
      findDiscountText(footer);

    const discountRow =
      findDiscountRow(
        footer,
        discountText
      );

    try {
      const shopRoot =
        window.Shopify &&
        window.Shopify.routes &&
        window.Shopify.routes.root
          ? window.Shopify.routes.root
          : '/';

      const response =
        await fetch(
          shopRoot + 'cart.js',
          {
            credentials: 'same-origin',
            headers: {
              Accept: 'application/json'
            }
          }
        );

      if (!response.ok) {
        return;
      }

      const cart =
        await response.json();

      const weightKg =
        (Number(cart.total_weight) || 0) /
        1000;

      const formattedWeight =
        weightKg.toFixed(2);

      let box =
        footer.querySelector(
          '.dgt-cart-weight'
        );

      /*
       * Create the row.
       */
      if (!box) {
        box =
          document.createElement('div');

        box.className =
          'dgt-cart-weight';

        const text =
          document.createElement('span');

        text.className =
          'dgt-cart-weight__text';

        box.appendChild(text);

        /*
         * Put it immediately before
         * the Discount code row.
         */
        if (discountRow) {
          footer.insertBefore(
            box,
            discountRow
          );
        } else {
          footer.prepend(box);
        }
      }

      /*
       * If Sections Store rebuilt the footer,
       * make sure our row is still positioned
       * immediately above Discount code.
       */
      if (
        discountRow &&
        box.nextElementSibling !==
          discountRow
      ) {
        footer.insertBefore(
          box,
          discountRow
        );
      }

      /*
       * Match the exact spacing of the
       * Discount code row.
       */
      copyRowSpacing(
        box,
        discountRow
      );

      const text =
        box.querySelector(
          '.dgt-cart-weight__text'
        );

      /*
       * Match the exact font/colour of
       * "Discount code".
       */
      copyTextStyles(
        text,
        discountText
      );

      if (
  box.dataset.weight !==
  formattedWeight
) {
  box.dataset.weight =
    formattedWeight;

  text.innerHTML =
    'Cart weight: ' +
    formattedWeight +
    ' kg' +
    '<div class="dgt-cart-weight__shipping-note">' +
      'Free Shipping offer applies to orders under 20kg (under 10kg for rural addresses) ' +
      '<a href="/pages/shipping-policy">Click here to learn more</a>' +
    '</div>';
}
    } catch (error) {
      console.error(
        'Cart weight display error:',
        error
      );
    }
  }

  function scheduleUpdate(
    delay = 200
  ) {
    clearTimeout(updateTimer);

    updateTimer =
      setTimeout(
        updateCartWeight,
        delay
      );
  }

  function initialiseCartWeight() {
    const host =
      document.querySelector(
        'section-store--cart-block'
      );

    /*
     * Wait for Sections Store's
     * Shadow DOM to become available.
     */
    if (
      !host ||
      !host.shadowRoot
    ) {
      setTimeout(
        initialiseCartWeight,
        500
      );

      return;
    }

    const root =
      host.shadowRoot;

    /*
     * Watch the drawer because Sections
     * Store rebuilds it after cart changes.
     */
    const observer =
      new MutationObserver(
        function () {
          scheduleUpdate(150);
        }
      );

    observer.observe(
      root,
      {
        childList: true,
        subtree: true
      }
    );

    /*
     * Quantity buttons, removal,
     * upsells, discounts, etc.
     */
    root.addEventListener(
      'click',
      function () {
        scheduleUpdate(500);
      }
    );

    root.addEventListener(
      'change',
      function () {
        scheduleUpdate(500);
      }
    );

    /*
     * Initial render.
     */
    updateCartWeight();
  }

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initialiseCartWeight
    );
  } else {
    initialiseCartWeight();
  }
})();